
import Vue from 'vue';
import { isEmpty, find } from 'lodash';
import { mapGetters } from 'vuex';
import AdsApi from '../../libs/ads-request/ads-api';
import VideoPlayer from '../../components/VideoPlayer.vue';
import AImage from '../../components/AImage.vue';
import AMoney from '../../components/AMoney.vue';
import 'video.js/dist/video-js.css';
import { fileExtensionValidation, addActivity, remapActivitiesByType } from '../../libs/helpers';
import numberToLetter from '../../libs/NumberToLetter';
import QuotationRules from '../../libs/business-logic/Quotation.rules';

export default {
  name: 'TechnicalReport',
  components: {
    VideoPlayer,
    AImage,
    AMoney,
  },
  props: {
    activity: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    slide: 1,
    orderActivityId: null,
    orderWork: {},
    thumbnails: [],
    clientComments: '',
    authorizationWindow: false,
    colorChip: '',
    textChip: '',
    total: 0,
    activitiesInPackage: [],
    evidences: [],
    activities: null,
    disabled: false,
    loaderMessage: 'Cargando detalle ...',
    loaderError: false,
    showView: false,
    showPrice: 0,
    activitiesByType: null,
  }),
  computed: {
    ...mapGetters('Quotation', {
      quotationItems: 'getQuotationItems',
    }),
    ...mapGetters('Activity', {
      activitiesGroupedById: 'getActivitiesGroupedById',
    }),
    ...mapGetters('Order', {
      taxPercentage: 'getTaxPercentage',
    }),
    getIvaAmount() {
      return (
        +this.activitiesByType.subtotalAmount
        * this.taxPercentage
      ).toFixed(2);
    },
    getTotalAmount() {
      return (+this.activitiesByType.subtotalAmount + +this.getIvaAmount).toFixed(2);
    },
    mobile() {
      return this.$q.screen.lt.md;
    },
    isInternal() {
      return this.$session.get('isInternal');
    },
    getActivitySubtotalAmount() {
      return QuotationRules.getSubtotalAmountOfActivity(
        this.activity.order_activity_id,
        this.quotationItems,
      );
    },
  },
  watch: {
    slide(val) {
      const evidence = find(this.evidences, (e) => e.files_id === val);
      if (evidence != null) {
        this.clientComments = evidence.client_comments;
      }
    },
    activity() {
      this.reset();
      this.initialCharge();
    },
  },
  mounted() {
    this.showPrice = Vue.prototype.$session.get('showPrice') ? Vue.prototype.$session.get('showPrice') : 0;
    this.initialCharge();
  },
  methods: {
    isEmpty,
    numberToLetter,
    acceptPoint() {
      this.$router.push({ name: 'checklist' });
    },
    changeActivity(activity) {
      const clonedActivity = activity;
      clonedActivity.accepted = !clonedActivity.accepted;
    },
    getOrderWork() {
      return AdsApi.getOrderWork(this.orderActivityId)
        .then(async (response) => {
          if (response.data.length === 0) return;

          const activities = response.data;
          let activitiesList = [];
          const packIds = [];
          const index = 0;
          let authorized = null;

          authorized = find(activities, (a) => a.accepted !== null);

          if (authorized != null) this.disabled = true;

          activities.forEach((activity) => {
            activitiesList = addActivity(activity, activitiesList, packIds);
          });

          this.orderWork = activitiesList[index];

          switch (this.orderWork.activity_status_id) {
            case 4:
              this.colorChip = 'negative';
              this.textChip = 'Reparación urgente';
              break;
            case 3:
              this.colorChip = 'neutral-yellow';
              this.textChip = 'Reparación preventiva';
              break;
            case 2:
              this.colorChip = 'positive';
              this.textChip = 'Punto sin reparación';
              break;
            default:
              break;
          }
        })
        .catch((err) => {
          throw err;
        });
    },
    getEvidence() {
      return AdsApi.getEvidence(this.orderActivityId)
        .then(async (response) => {
          const { data } = response;

          this.orderWork.technical = data.name;

          if (data.evidence.length > 0) {
            this.evidences = data.evidence.map((evidence) => {
              const evidenceCloned = evidence;
              evidenceCloned.key = evidence.files_id;

              const type = fileExtensionValidation(evidenceCloned.url);

              if (type === 'image') {
                evidenceCloned.type = type;
                evidenceCloned.media = evidenceCloned.url;
              }

              if (type === 'video') {
                evidenceCloned.type = type;
                evidenceCloned.media = {
                  autoplay: false,
                  controls: true,
                  responsive: true,
                  sources: [
                    {
                      src: evidenceCloned.url,
                    },
                  ],
                };
              }

              return evidenceCloned;
            });

            this.thumbnails = this.evidences.map((evidence) => ({
              value: evidence.files_id,
              slot: evidence.key,
              src:
                  evidence.type === 'image'
                    ? evidence.url
                    : {
                      autoplay: false,
                      controls: false,
                      responsive: false,
                      aspectRatio: '4:3',
                      sources: [
                        {
                          src: evidence.url,
                        },
                      ],
                    },
              type: evidence.type,
            }));

            this.clientComments = this.evidences[0].client_comments;
            this.slide = this.evidences[0].files_id;
          }
        })
        .catch((err) => {
          throw err;
        });
    },
    getActivitiesInPackage() {
      return AdsApi.getActivitiesInPackage(this.orderWork.pack_id)
        .then(async (response) => {
          const { data } = response;

          data.forEach((activity) => {
            const object = find(
              this.activitiesInPackage,
              (a) => a.order_activity_id === activity.order_activity_id,
            );
            if (object == null) this.activitiesInPackage.push(activity);
          });
        })
        .catch((err) => {
          throw err;
        });
    },
    async initialCharge() {
      try {
        this.orderActivityId = this.$route.params.id || this.activity.order_activity_id;
        await this.getOrderWork();
        await this.getEvidence();
        this.activitiesByType = remapActivitiesByType(
          this.activitiesGroupedById[this.orderActivityId],
        );
        if (this.orderWork.pack_id_dms != null) await this.getActivitiesInPackage();
        this.showView = true;
      } catch (error) {
        this.alertShow(error, 'error');
        this.loaderError = true;
      }
    },
    redirectToChecklist() {
      if (typeof this.activity !== 'undefined') {
        if (this.activity.activity_status_id === 2 && this.activity.inventario === 1) {
          this.$router.push({
            name: 'inventario',
          });
        } else {
          this.$router.push({
            name: 'checklist',
          });
        }
      } else {
        setTimeout(() => {
          this.$router.push({
            name: 'home',
          });
        }, 5000);
      }
    },
    remapMyList(list) {
      list.map((element) => {
        const clonedElement = element;
        if (clonedElement.order_activity_id === this.orderWork.order_activity_id) {
          clonedElement.accepted = this.orderWork.accepted;
        }
        return clonedElement;
      });
    },
    reset() {
      this.slide = null;
      this.orderWork = {};
      this.thumbnails = [];
      this.clientComments = '';
      this.authorizationWindow = false;
      this.colorChip = '';
      this.textChip = '';
      this.total = 0;
      this.activitiesInPackage = [];
      this.evidences = [];
      this.loaderError = false;
      this.showView = false;
    },
    close() {
      this.$emit('close');
    },
  },
};
